'use client';

import { useState, useEffect } from 'react';
import { KbvPluginService } from '@/services/kbvPluginService';
import { groupByLeague } from '@/utils/favoritesLeagues';

function getRaw(result) {
  return result?.data?.data ?? result?.data;
}

export default function useFavoriteMatches(queryObject) {
  const enabled = Boolean(queryObject);
  const [leaguesWithMatches, setLeaguesWithMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setLeaguesWithMatches([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const result = await KbvPluginService.fetchFavoritesPublic(queryObject);
        if (cancelled) return;
        setLeaguesWithMatches(groupByLeague(getRaw(result)));
      } catch {
        if (!cancelled) setLeaguesWithMatches([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [JSON.stringify(queryObject), enabled]);

  return {
    leaguesWithMatches,
    loading,
    matches: leaguesWithMatches.flatMap((g) => g.matches || []),
  };
}
